<template>
  <el-switch
    active-text="持续跟踪"
    inactive-text="持续跟踪"
    inline-prompt
    v-model="ifContinuousTracking"
    :style="{
      // '--el-switch-off-color': '#ff4949',
      '--el-switch-on-color': '#13ce66',
    }"
    v-if="isSuperAdmin"
  ></el-switch>
  <br>
  <el-switch
    active-text="持续统计"
    inactive-text="持续统计"
    inline-prompt
    v-model="ifContinuousStatistics"
    :style="{
      '--el-switch-on-color': '#13ce66',
    }"
  ></el-switch>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive, markRaw,
  h, defineComponent, toRaw,
} from 'vue';
import store from '@/store';
import { isNull, dayjs, message, vueCreateAppInit } from '@/utils/js/initVariable';
// props
const props = defineProps({
  ifContinuousTracking: { type: Boolean, },
  ifContinuousStatistics: { type: Boolean, },
});
// emit
const emit = defineEmits([
  'update:ifContinuousTracking', 'update:ifContinuousStatistics',
]);

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{

});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

const isSuperAdmin = computed(() => store.getters['isSuperAdmin']);

const ifContinuousTracking = computed({
  get: () => props.ifContinuousTracking,
  set: (val) => emit('update:ifContinuousTracking', val)
})
const ifContinuousStatistics = computed({
  get: () => props.ifContinuousStatistics,
  set: (val) => emit('update:ifContinuousStatistics', val)
})

</script>

<style lang='less'>

</style>

<style lang='less' scoped>
</style>